export const BackendURL = process.env.REACT_APP_BASE_URL